import { useAppMode } from './appMode';

export function PresenterProgress({
  current,
  total,
  label,
}: {
  current: number;
  total: number;
  label: string;
}) {
  const { mode } = useAppMode();
  if (mode !== 'presenter') return null;
  const safeTotal = Math.max(1, total);
  const progress = Math.min(1, Math.max(0, current / safeTotal));

  return (
    <aside className="pointer-events-none fixed inset-x-0 top-0 z-40" aria-label={`進行状況 ${current}/${total}`}>
      <div className="h-1.5 bg-atc-navy/10">
        <div
          className="h-full bg-atc-primary transition-[width] duration-300"
          style={{ width: `${progress * 100}%` }}
        />
      </div>
      <div className="absolute left-6 top-5 rounded-full border border-atc-navy/15 bg-white px-4 py-2 text-xs font-bold tracking-[0.18em] text-atc-navy shadow-sm">
        {label} · {String(current).padStart(2, '0')}/{String(total).padStart(2, '0')}
      </div>
    </aside>
  );
}
